import {
	ClientCarBodyTypeEnum,
	ClientPropertyCarVehicleTypeEnum,
	type ClientPropertyVehicleDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { CAR_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/CarForm/carFormDefaults";
import type { CarFormInput } from "web_myplann/Portfolio/Forms/CarForm/carFormSchema";
import {
	parseIsoDate,
	parseMonthYear,
} from "web_myplann/Portfolio/Forms/dateParsers";
import { toSelectedKeys } from "web_myplann/Portfolio/Helpers/carBooleanGroups";
import { CAR_SECURITY_TYPES } from "web_myplann/Portfolio/Helpers/carSecurityTypes";
import { CAR_SPECIAL_EQUIPMENT } from "web_myplann/Portfolio/Helpers/carSpecialEquipment";

const UNFILLED_BODY_TYPES: ClientCarBodyTypeEnum[] = [
	ClientCarBodyTypeEnum.None,
	ClientCarBodyTypeEnum.DEPRECATED_EMPTY,
];

const UNFILLED_VEHICLE_TYPES: ClientPropertyCarVehicleTypeEnum[] = [
	ClientPropertyCarVehicleTypeEnum.None,
	ClientPropertyCarVehicleTypeEnum.Empty,
];

const toFilledEnum = <TEnum extends string>(
	value: TEnum | null | undefined,
	unfilledValues: TEnum[],
): TEnum | null => (value && !unfilledValues.includes(value) ? value : null);

export const mapPropertyToCarForm = (
	property: ClientPropertyVehicleDetailResponseDTO,
): CarFormInput => ({
	carBrand: property.carBrand ?? DEFAULTS.carBrand,
	carModel: property.carModel ?? DEFAULTS.carModel,
	propertyType: property.propertyType ?? DEFAULTS.propertyType,
	carVehicleType: toFilledEnum(property.carVehicleType, UNFILLED_VEHICLE_TYPES),
	carSerialNumber: property.carSerialNumber ?? DEFAULTS.carSerialNumber,
	carMaxSpeed: property.carMaxSpeed ?? DEFAULTS.carMaxSpeed,
	carFuel: property.carFuel ?? DEFAULTS.carFuel,
	carLicensePlate: property.carLicensePlate ?? DEFAULTS.carLicensePlate,
	carVin: property.carVin ?? DEFAULTS.carVin,
	value: property.value ?? DEFAULTS.value,
	carPurchaseDate: parseIsoDate(property.carPurchaseDate),
	carRegistration: parseIsoDate(property.carRegistration),
	carManufactureMonthYear: parseMonthYear(property.carManufactureMonthYear),
	carPower: property.carPower ?? DEFAULTS.carPower,
	carVolume: property.carVolume ?? DEFAULTS.carVolume,
	carBodyType: toFilledEnum(property.carBodyType, UNFILLED_BODY_TYPES),
	carWeight: property.carWeight ?? DEFAULTS.carWeight,
	carSeatCount: property.carSeatCount ?? DEFAULTS.carSeatCount,
	carPutIntoService: parseIsoDate(property.carPutIntoService),
	carSecurity: toSelectedKeys(CAR_SECURITY_TYPES, property),
	carSpecialEquipment: toSelectedKeys(CAR_SPECIAL_EQUIPMENT, property),
	description: property.description ?? DEFAULTS.description,
	forInvestments: property.forInvestments ?? DEFAULTS.forInvestments,
});
